import { lockScreenScroll } from '../utils/treatment';
import { hideSidebarFixed } from './sidebarFixed';
import { showPartialsFixed } from './partialsFixed';


const btnCallFilterProducts = document.querySelectorAll('.button-call-filter-products');
const closeFilterProductsMobile = document.querySelectorAll('.btn-close-filter-products');
const filterHeader = document.querySelector('.header-filter');
const filterProductMobile = document.querySelector('.filter-product-mobile');
const selectModelsWrapper = document.querySelectorAll("select[name=produto]");
const selectDepartmentWrapper = document.querySelectorAll("select[name=department]");

const headerScrolled = document.querySelector('.header-fixed');
const sidebarFixed = document.querySelector('.sidebar-fixed');

const pageURLParameter = window.location.pathname;


// FUNCTION TO CONTROL BEHAVIOR OF COTATION BUTTONS
export function buttonCotationBehavior(button) {
  let buttonSelected = document.querySelectorAll(button);

  buttonSelected.forEach((btn) => {
    btn.addEventListener('click', () => {

      if(filterHeader && filterHeader.classList.contains('filter-header-fixed')) {
        hideFixedFilter();
        lockScreenScroll();
      }

      if (sidebarFixed && sidebarFixed.classList.contains('d-flex')) {
        hideSidebarFixed('.sidebar');
        lockScreenScroll();
      }

      if (btn.classList.contains('button-product-cotation')) {
        const dataModel = btn.getAttribute("data-model");
        const dataId = btn.getAttribute("data-id");
        const dataDepartment = btn.getAttribute("data-department");

        if (dataId)
          swapSelect(dataId, dataModel);

          selectModelsWrapper.forEach((select) => {
          select.value = dataModel;
        });


        if (window.innerWidth >= 992) {
          if (!headerScrolled.classList.contains('show-header-scrolled')) {
            setTimeout(() => {
              if (pageURLParameter == '/novos') {
                window.scrollTo(0, 130);
              } else {
                window.scrollTo(0, 710);
              }
            }, 50);

            showPartialsFixed('.header-fixed', 'show-header-scrolled', 'hide-header-scrolled');
          }
        }

        lockScreenScroll();

      } else if(btn.classList.contains('button-services-cotation')) {
        const dataModel = btn.getAttribute("data-model");

        selectModelsWrapper.forEach((select) => {
          select.value = dataModel;
        });

      } else {
        showFixedForm();
        lockScreenScroll();
      }
    });
  });
}

// FUNCTION TO CONTROL BEHAVIOR OF FILTERS BUTTONS
export function buttonFilterBehavior(button) {
  let buttonSelected = document.querySelectorAll(button);

  buttonSelected.forEach((btn) => {
    btn.addEventListener('click', () => {

      if (sidebarFixed && sidebarFixed.classList.contains('d-flex')) {
        hideSidebarFixed('.sidebar');
        lockScreenScroll();
      }

      // Verifica qual botão foi clicado e mostra o filtro correspondente
      if (btn.classList.contains('button-call-filter-products')) {
        showFixedFilterProduct();
      } 
      
      lockScreenScroll();
    });
  });
}



// FUNCTION TO SHOW FIXED FILTER
function showFixedFilterProduct() {
  if (window.innerWidth >= 992) {
    btnCallFilterProducts.forEach((btn) => {
      btn.innerHTML === '<i class="icon-fechar-light text-white mr-2"></i>Fechar'
      ? btn.innerHTML = `<i class="icon-lupa"></i> Buscar produto`
      : btn.innerHTML = '<i class="icon-fechar-light text-white mr-2"></i>Fechar';
    });

    filterHeader.classList.toggle('filter-header-fixed');
  } else {
    filterProductMobile.classList.add('d-flex');
  }
}


// BUTTON TO CLOSE FILTER IN MOBILE
closeFilterProductsMobile.forEach((btnClose) => {
  btnClose.addEventListener('click', () => {
    filterProductMobile.classList.remove('d-flex');
    lockScreenScroll();
  });
})






